import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { CustomToastProvider } from './contexts/CustomToastContext';
import { SocketProvider } from './contexts/SocketContext';
import ThemeProvider from './contexts/ThemeContext';
import App from './App';
import 'react-datepicker/dist/react-datepicker.css';
import './index.scss';
import { HomeContextProvider } from './contexts/HomeContext';
import { BlocksContextProvider } from './contexts/BlocksContext';
import { TransactionsContextProvider } from './contexts/TransactionsContext';
import { SmartContractsContextProvider } from './contexts/SmartContractsContext';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <ThemeProvider>
    <BrowserRouter>
      <CustomToastProvider>
        <BlocksContextProvider>
          <TransactionsContextProvider>
            <SmartContractsContextProvider>
              <HomeContextProvider>
                <SocketProvider>
                    <App/>
                </SocketProvider>
              </HomeContextProvider>
            </SmartContractsContextProvider>
          </TransactionsContextProvider>
        </BlocksContextProvider>
      </CustomToastProvider>
    </BrowserRouter>
  </ThemeProvider>
);
